import ApiService, { IRequestParameters } from '@/plugins/api-plugin/services/api.service'
import { PageNumberPagination } from '@/interfaces/common/PageNumberPagination'

export default class SpCollectorService extends ApiService {
    async getListings(params?: IRequestParameters): Promise<[any[], PageNumberPagination] | null> {
        return this.request<undefined, [any[], PageNumberPagination] | null>(
            'GET',
            '/sp-collector/listings',
            params,
            undefined,
            undefined,
            'getListings',
        ).catch(() => null)
    }

    async getStats(): Promise<any | null> {
        return this.request<undefined, any | null>(
            'GET',
            '/sp-collector/stats',
            undefined,
            undefined,
            undefined,
            'getStats',
        ).catch(() => null)
    }

    async getDistinctRegions(): Promise<string[] | null> {
        return this.request<undefined, string[] | null>(
            'GET',
            '/sp-collector/distinct/regions',
            undefined,
            undefined,
            undefined,
            'getDistinctRegions',
        ).catch(() => null)
    }

    async getDistinctSellers(): Promise<string[] | null> {
        return this.request<undefined, string[] | null>(
            'GET',
            '/sp-collector/distinct/sellers',
            undefined,
            undefined,
            undefined,
            'getDistinctSellers',
        ).catch(() => null)
    }

    async getDistinctMarketplaces(): Promise<string[] | null> {
        return this.request<undefined, string[] | null>(
            'GET',
            '/sp-collector/distinct/marketplaces',
            undefined,
            undefined,
            undefined,
            'getDistinctMarketplaces',
        ).catch(() => null)
    }

    async getListingDetails(id: string): Promise<Record<string, any> | null> {
        return this.request<undefined, Record<string, any> | null>(
            'GET',
            `/sp-collector/listings/${id}/details`,
            undefined,
            undefined,
            undefined,
            'getListingDetails',
        ).catch(() => null)
    }

    async getListingById(id: string): Promise<any | null> {
        return this.request<undefined, any | null>(
            'GET',
            `/sp-collector/listings/${id}`,
            undefined,
            undefined,
            undefined,
            'getListingById',
        ).catch(() => null)
    }

    async getSpCollectorWhiteList(): Promise<Record<string, unknown> | null> {
        return this.request<undefined, Record<string, unknown> | null>(
            'GET',
            '/sp-collector/whitelist',
            undefined,
            undefined,
            undefined,
            'getSpCollectorWhiteList',
        ).catch(() => null)
    }

    async updateSpCollectorWhiteList(whiteList: Record<string, unknown>): Promise<Record<string, unknown> | null> {
        return this.request<{ whiteList: Record<string, unknown> }, Record<string, unknown> | null>(
            'PUT',
            '/sp-collector/whitelist',
            undefined,
            { whiteList },
            undefined,
            'updateSpCollectorWhiteList',
        ).catch(() => null)
    }

    async getSpCollectorRateLimits(): Promise<Record<string, Record<string, number>> | null> {
        return this.request<undefined, Record<string, Record<string, number>> | null>(
            'GET',
            '/sp-collector/rate-limits',
            undefined,
            undefined,
            undefined,
            'getSpCollectorRateLimits',
        ).catch(() => null)
    }

    async updateSpCollectorRateLimits(
        rateLimits: Record<string, Record<string, number>>,
    ): Promise<Record<string, Record<string, number>> | null> {
        return this.request<
            { rateLimits: Record<string, Record<string, number>> },
            Record<string, Record<string, number>> | null
        >(
            'PUT',
            '/sp-collector/rate-limits',
            undefined,
            { rateLimits },
            undefined,
            'updateSpCollectorRateLimits',
        ).catch(() => null)
    }

    async searchDefinitionsProductTypes(
        params: IRequestParameters,
    ): Promise<{ data: any[]; total: number; page: number; limit: number } | null> {
        return this.request<undefined, { data: any[]; total: number; page: number; limit: number }>(
            'GET',
            '/sp-collector/results/search-definitions-product-types-results',
            params,
            undefined,
            undefined,
            'searchDefinitionsProductTypes',
        ).catch(() => null)
    }

    async getDefinitionsProductTypes(
        params: IRequestParameters,
    ): Promise<{ data: any[]; total: number; page: number; limit: number } | null> {
        return this.request<undefined, { data: any[]; total: number; page: number; limit: number }>(
            'GET',
            '/sp-collector/results/get-definitions-product-type-results',
            params,
            undefined,
            undefined,
            'getDefinitionsProductTypes',
        ).catch(() => null)
    }
}
